import {DepartmentEditationMode, type Department} from 'src/typings';
import type {CurrentAuthService, FinishedResponseInteractionService} from 'shared/services';
import type RegistrationService from 'shared/login/registration.service';
import type LoginService from 'shared/login/login.service';
import type DepartmentDataService from 'src/features/departments/services/department.data-service';

export class DepartmentCreatedModalService {
    public static serviceName = 'departmentCreatedModalService';

    /*@ngInject*/
    constructor(private registrationService: RegistrationService,
                private loginService: LoginService,
                private currentAuthService: CurrentAuthService,
                private currentDepartment: Department,
                private departmentDataService: DepartmentDataService,
                private finishedResponseInteractionService: FinishedResponseInteractionService,
                private SERVER_URL: string) {
    }


    public getHost(): string {
        return this.SERVER_URL
            .replace('http://', '')
            .replace('https://', '');
    }

    public async activateDepartment() {
        const actionResponse = await this.departmentDataService.activate(this.currentDepartment, this.currentAuthService.getActiveUser());
        await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
    }

    public async registerWithEditorAccount() {
        await this.registrationService.savePersonByForm({}, {});
    }

    public async loginAndAddEditorAccount() {
        await this.loginService.login();
        await this.addEditorAccount();
    }

    public async addEditorAccount() {
        await this.registrationService.savePersonWithDepartmentByForm(
            null,
            {},
            {department: this.currentDepartment, departmentEditationMode: DepartmentEditationMode.MERGE_DUPLICATES_OR_APPEND},
            {department: this.currentDepartment, departmentEditationMode: DepartmentEditationMode.MERGE_DUPLICATES_OR_APPEND}
        );

    }
}